window.upholsteryHandler = () => {
  window.isResourcesPageLoaded = false;
  document.addEventListener('DOMContentLoaded', () => {
    activeTabsAfterPageIsLoaded();
    finishesTabEvents();
  });


  // Set active tabs after first page loading only in Resources Page
  const activeTabsAfterPageIsLoaded = () => {
    if (!isResourcesPageLoaded) {
      const groupList = document.querySelector('.jsDownloadFinishes');
      if (!groupList)
        return
      const groupItems = groupList.querySelectorAll('.jsListDropdownItem');

      const downloadFinishModal = document.querySelector('.jsModalDownloadFinish');
      const downloadFinishModalOverlay = downloadFinishModal.querySelector('.jsModalDownloadFinishOverlay');
      const downloadFinishModalImage = downloadFinishModal.querySelector('.jsModalDownloadFinishImage');
      const downloadFinishModalLink = downloadFinishModal.querySelector('.jsModalDownloadFinishDownloadLink');
      const downloadFinishModalContainer = downloadFinishModal.querySelector('.jsModalDownloadFinishContainer');
      const successfulSaveText = downloadFinishModal.querySelector('.jsAddFinishModalSuccessfulSaveText');
      const successfulSaveProjectNameText = successfulSaveText.querySelector('span');
      const visitMySpacestorButton = downloadFinishModal.querySelector('.jsAddFinishModalMySpacestorButton');
      const addButton = document.querySelector('.jsAddFinishModalAddButton');

      let selectedFinishId = null;

      const openModal = ({imageSrc, finishId}) => {
        successfulSaveText.style.display = 'none';
        visitMySpacestorButton.style.display = 'none';
        addButton.style.display = 'inline-block';
        downloadFinishModal.classList.add('active');
        document.body.style.overflow = 'hidden';
        downloadFinishModalLink.href = imageSrc;
        downloadFinishModalImage.src = imageSrc;
        selectedFinishId = finishId;
      }

      const closeFinishModal = () => {
        downloadFinishModal.classList.remove('active');
        document.body.style.overflow = '';
        $('.jsModalAddFinishContainer').find('.jsSlideList').slideUp();
        const modal = document.querySelector('.jsModalAddFinishContainer');
        const selectLinkButton = modal.querySelector('.jsLinkButton');
        selectLinkButton.classList.remove('active');
        const selectText = modal.querySelector('.jsSelectFilterName');
        selectText.textContent = 'Choose project';
        selectText.classList.remove('add-finish-modal__select-text-active');
      }

      downloadFinishModalOverlay.addEventListener('click', () => {
        closeFinishModal();
      });

      const addFinishToProject = () => {
        const modal = document.querySelector('.jsModalAddFinishContainer');
        const closeButton = document.querySelector('.jsAddFinishModalCloseButton');
        const selectOptions = modal.querySelectorAll('.jsSelectOption');
        const selectLinkButton = modal.querySelector('.jsLinkButton');
        const selectText = modal.querySelector('.jsSelectFilterName');

        let selectedProjectId = null;

        const saveFinishToProject = () => {
          const url = '/api/users/user-finishes/'
          $.ajax({
            type: 'POST',
            url,
            data: {
              project: selectedProjectId,
              finish_material: selectedFinishId
            },
            success: (data) => {
              successfulSaveText.style.display = 'block';
              successfulSaveProjectNameText.innerText = ` ${selectText.innerText}`
              visitMySpacestorButton.style.display = 'inline-block';
              visitMySpacestorButton.href = `/myspacestor/myprojects/`
              addButton.style.display = 'none';
            },
            error: (data) => console.log('failure ' + data),
            headers: {
              'X-CSRFToken': getCookie('csrftoken')
            }
          })
        }

        const hideSelectList = () => {
          $('.jsModalAddFinishContainer').find('.jsSlideList').slideUp();
          selectLinkButton.classList.remove('active');
        }

        const handleClickSelectOption = (selectOption) => {
          selectedProjectId = selectOption.querySelector('.jsSelectOptionInput')?.id;
          selectText.textContent = selectOption.querySelector('.jsSelectOptionInput')?.dataset.projectName;
          selectText.classList.add('add-finish-modal__select-text-active')
          hideSelectList();
        }

        selectOptions.forEach(el => {
          el.addEventListener('click', () => {
            handleClickSelectOption(el)
          })
        })

        closeButton.addEventListener('click', closeFinishModal);
        addButton.addEventListener('click', () => {
          saveFinishToProject();
          hideSelectList();
          selectedFinishId = null;
          selectedProjectId = null;
        })

        const addNewProjectButton = document.querySelector('.jsFinishSelectAddProject');
        addNewProjectButton.addEventListener('click', () => {
          $('.jsModalFinishAddProject').addClass('active')
          $('.jsModalFinishAddProject').show()
        })

        document.querySelector('.jsModalFinishAddProjectSubmit').addEventListener('click', function (e) {
          e.preventDefault();
          const projTitle = document.querySelector('.jsFinishModalAddProjTitleBtn').value;

          $.ajax({
            type: 'POST',
            url: '/myspacestor/add-project/',
            data: {
              'projectName': projTitle
            },
            success: (data) => {
              const newProjId = data.projectData.id;
              const newProjName = data.projectData.name;

              const element = `
                <li class="customizer-options__item__desc__form__input__list__item">
                    <label class="jsSelectOption" for="${newProjId}">
                        <input type="radio" name="project" data-project-name="${newProjName}" id="${newProjId}" value="${newProjId}" class="jsSelectOptionInput">
                        ${newProjName}
                    </label>
                </li>
            `;
              const slideList = document.querySelector('.jsFinishSlideList');
              slideList.insertAdjacentHTML('afterbegin', element);

              const newInput = slideList.querySelector(`li .jsSelectOptionInput[value="${newProjId}"]`);
              if (newInput) {
                const selectOption = newInput.closest('.jsSelectOption')
                handleClickSelectOption(selectOption)
              }

              document.querySelector('.jsModalFinishAddProject .jsModalContentClose').click();
            },
            error: (data) => {
              console.log('failure ' + data)
            },
            headers: {
              'X-CSRFToken': getCookie('csrftoken')
            }
          })
        });


      }


      addFinishToProject();

      groupItems.forEach(item => {
        const categoriesList = item.querySelector('.jsFinishCategories');
        const finishes = item.querySelectorAll('.jsFinishGroup');


        finishes.forEach(finish => {
          const imageWrappers = finish.querySelectorAll('.jsUpholsteryItemImage')
          imageWrappers.forEach(element => {
            element.addEventListener('click', () => {
              const imageWrapper = element.querySelector('.jsMaterialImageWrapper');
              const imageSrc = imageWrapper.dataset.src;
              const finishId = imageWrapper.dataset.finishId;
              openModal({imageSrc: imageSrc, finishId: finishId});
            })
          })

        })

        // Set active for first category
        if (categoriesList) {
          const categories = categoriesList.querySelectorAll('.jsUpholsteryCategoriesCategory');
          const category = categories[0];

          category.classList.add('active');
        }

        if (finishes.length > 0) {
          finishes.forEach((finish, index) => {
            if (categoriesList) {
              // Set active for first finish group in each main group
              if (index === 0) {
                const finishGroupName = finish.querySelector('.jsUpholsteryGroupName');
                const finishGroupItems = finish.querySelector('.jsUpholsteryGroupItems');

                finish.classList.add('active');
                finishGroupName.classList.add('opened');
                finishGroupItems.classList.add('opened');
              }
            } else {
              finish.classList.add('active');
            }
          });
        }
      });

      window.isResourcesPageLoaded = true;
    }
  }


  // Finishes
  const finishesTabEvents = () => {
    const upholsteryCategories = document.querySelectorAll('.jsUpholsteryCategoriesCategory');
    const upholsteryGroups = document.querySelectorAll('.jsUpholsteryGroupName');

    upholsteryCategories?.forEach(category => {
      category.addEventListener('click', () => {
        const upholstery = category.closest('.jsUpholstery');
        const thisType = category.closest('.jsUpholsteryCategoriesCategory');
        const finishesType = upholstery.querySelectorAll('.jsUpholsteryCategoriesCategory');
        const finishesGroups = upholstery.querySelectorAll('.jsFinishGroup');
        let selectedIndex = 0;

        finishesType?.forEach((type, index) => {
          if (type === thisType) {
            type.classList.toggle('active');
            selectedIndex = index;
          } else {
            type.classList.remove('active');
          }
        });

        finishesGroups?.forEach((group, index) => {
          if (index === selectedIndex) {
            group.classList.toggle('active')
          } else {
            group.classList.remove('active')
          }
        });
      });
    });

    upholsteryGroups?.forEach(group => {
      group.addEventListener('click', () => {
        // Show/hide finished after clicked finish group
        group.classList.toggle('opened');
        group.parentElement.querySelector('.jsUpholsteryGroupItems').classList.toggle('opened');
      });
    });
  }
};
